// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._13t3idpf span{line-height:0}
._154ix0bf{top:var(--ds-space-negative-100,-8px)}
._1bsbf6fq{width:18px}
._1e0c1txw{display:flex}
._1pbykb7n{z-index:1}
._1xi2x0bf{right:var(--ds-space-negative-100,-8px)}
._3um015vq{visibility:hidden}
._4t3if6fq{height:18px}
._kqswstnw{position:absolute}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/common/DeleteButton.compiled.css"],"names":[],"mappings":"AAAA,gBAAgB,aAAa;AAC7B,WAAW,qCAAqC;AAChD,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,SAAS;AACpB,WAAW,uCAAuC;AAClD,WAAW,iBAAiB;AAC5B,WAAW,WAAW;AACtB,WAAW,iBAAiB","sourcesContent":["._13t3idpf span{line-height:0}\n._154ix0bf{top:var(--ds-space-negative-100,-8px)}\n._1bsbf6fq{width:18px}\n._1e0c1txw{display:flex}\n._1pbykb7n{z-index:1}\n._1xi2x0bf{right:var(--ds-space-negative-100,-8px)}\n._3um015vq{visibility:hidden}\n._4t3if6fq{height:18px}\n._kqswstnw{position:absolute}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
